import { useState, type FormEvent } from 'react'

export type RangeKey = 'week' | 'month' | 'year' | 'custom'
export interface RangeValue {
  range: RangeKey
  from: string
  to: string
}

const OPTS: { key: RangeKey; label: string }[] = [
  { key: 'week', label: 'Week' },
  { key: 'month', label: 'Month' },
  { key: 'year', label: 'Year' },
  { key: 'custom', label: 'Custom' },
]

function isoDaysAgo(days: number): string {
  return new Date(Date.now() - days * 86_400_000).toISOString().slice(0, 10)
}

// Dashboard-style timeframe control (week / month / year / custom). Presets apply
// immediately; custom applies on the button.
export function RangePicker({
  value,
  onChange,
}: {
  value: RangeValue
  onChange: (v: RangeValue) => void
}) {
  const [from, setFrom] = useState(value.from || isoDaysAgo(365))
  const [to, setTo] = useState(value.to || isoDaysAgo(0))

  function pick(range: RangeKey) {
    if (range === 'custom') onChange({ range: 'custom', from, to })
    else onChange({ range, from: '', to: '' })
  }
  function applyCustom(e: FormEvent) {
    e.preventDefault()
    if (!from || !to || from > to) return
    onChange({ range: 'custom', from, to })
  }

  return (
    <div>
      <div className="seg">
        {OPTS.map((o) => (
          <button
            key={o.key}
            className={o.key === value.range ? 'seg-btn active' : 'seg-btn'}
            onClick={() => pick(o.key)}
          >
            {o.label}
          </button>
        ))}
      </div>
      {value.range === 'custom' && (
        <form className="range-picker" style={{ marginTop: 10 }} onSubmit={applyCustom}>
          <div className="field" style={{ margin: 0 }}>
            <label>From</label>
            <input type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} required />
          </div>
          <div className="field" style={{ margin: 0 }}>
            <label>To</label>
            <input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} required />
          </div>
          <button className="btn btn-primary" type="submit">Apply</button>
        </form>
      )}
    </div>
  )
}
